export const CHECKED_URLS = 'checkedUrls';
export const CUSTOM_CHAIN_MESSAGE = 'customChainMessage';
export const IS_GEEK_MODE = 'isGeekMode';
